import { getReceivingFeeForSingleItem } from './get-receiving-fee-for-single-item.logic';
export default function getReceivingFeeForItemsList(items) {
  return items.reduce((sum, item) => sum + getReceivingFeeForSingleItem(item), 0);
}